var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.curriculum_details)+" ")])],1),_c('v-btn',{on:{"click":_vm.testing}},[_vm._v(" Test me ")]),_c('MakeAdminForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }